window.addEventListener("onSubmitForm", () => {
  window.dataLayer.push({
    event: "kontakt_odeslan",
  });

  console.log("✅ GTM event kontakt_odeslan");
});
